import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        backgroundColor: 'background.default',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="xl">
        <Typography variant="body2" color="text.secondary" align="center">
          PhD. Research Application - By Godar J. Ibrahim
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          godar.ibrahim@su.edu.krd
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          +964 (0) 750 723 2323
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
